export default "/images/c82e9631a94c9b8b3039cb801432962b.jpg";